import f1 from "../images/SwipeImages/f1.jfif";
import f2 from "../images/SwipeImages/f2.jpg";
import f5 from "../images/SwipeImages/f5.png";
import f6 from "../images/SwipeImages/f6.jpg";
import f7 from "../images/SwipeImages/f7.jpg";
import f11 from "../images/SwipeImages/f11.jpg";
import f12 from "../images/SwipeImages/f12.jpg";

const Item = [
  {
    id: 1,
    image: f1,
    name: "Winter Wear",
  },
  {
    id: 2,
    image: f2,
    name: "Womens Wear",
  },

  {
    id: 5,
    image: f6,
    name: "Casuals",
  },
  {
    id: 6,
    image: f5,
    name: "Indian Classics",
  },

  {
    id: 8,
    image: f11,
    name: "Festive Wear",
  },
  {
    id: 9,
    image: f12,
    name: "Traditional Wear",
  },
  {
    id: 7,
    image: f7,
    name: "Mens Wear",
  },
];

export default Item;
